import { configureStore } from "@reduxjs/toolkit";
import mdUploadSlice from "./reducers/mdUploadSlice";

export const store = configureStore({
    reducer: { mdUpload: mdUploadSlice.reducer },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
